console.log('main.js loaded');
// main
import './app/jquery-ui-1.10.3.custom.min.js';
import './app/jquery.hoverIntent.r7';
import './app/jquery.cycle.all.js';
import './app/swiper.min.js';
import './app/qaptcha/jquery.ui.touch-punch.js';
import './app/qaptcha/QapTcha.jquery.js';
$(function () {
    $('.qap3.QapTcha').QapTcha({
        disabledSubmit: true,
        autoRevert: false
    });
});